export default "__VITE_ASSET__ypv0FpdU__"